@for (week of stats; track week) {
  <ng-container class="week">
    @for (day of week; track day) {
      <div class="day">
        {{ day.dayOfWeek }}
        <span [ngStyle]="{ 'width.%': day.p }" [title]="day.counter"> </span>
      </div>
    }
  </ng-container>
}
